/**
 * takes a string and tries to convert it to partial German date format,\
 * filtering letters, inserting separating points, and limiting numeric input, i.e. no day beyond the 31st, no month beyond December,
 * and with this being specifically meant to be used with dates of birth, disallowing years in the future
 * @param input
 */
export const partialGermanDateFormat = (input: string) => {
  // stripping all non-digit characters
  const numeric = input.replaceAll(/\D/g, '')
  const currentYear = new Date().getFullYear().toFixed(0)

  // separate digits, assuming format DDMMYYYY
  let [d1 = '', d2 = '', m1 = '', m2 = '', y1 = '', y2 = '', y3 = '', y4 = ''] = numeric

  if (d1) {
    if (!d2 && Number(d1) > 3) {
      // when entering a date < 10 without a leading zero moves that date to d2 and pads it with a zero
      d2 = d1
      d1 = '0'
    } else {
      d1 = Math.min(3, Number(d1)).toFixed(0)
    }
  }

  if (d2) {
    if (d1 === '3' && Number(d2) > 1) {
      // when entering first a 3 and then a digit x > 1, assumes the day part to be `03` and x to be the (first part of the) month
      d1 = '0'
      m1 = d2
      d2 = '3'
    }
  }

  if (m1) {
    if (!m2 && Number(m1) > 1) {
      // when entering a month < 10 without a leading zero, moves that month to m2 and pads it with a zero
      m2 = m1
      m1 = '0'
    } else {
      m1 = Math.min(1, Number(m1)).toFixed(0) // disallowing a leading digit > 0
    }
  }

  if (m2) m2 = m1 === '1' ? Math.min(2, Number(m2)).toFixed(0) : m2 // disallowing a trailing digit > 2 if the leading digit was 1

  // all year parts are capped at the respective part of the current year

  if (y1) {
    if (!y2 && !y3 && !y4 && Number(y1) > 2) {
      // when entering a digit > 2, assumes two-digit format and
      y3 = y1
      y1 = '1'
      y2 = '9'
    } else {
      y1 = Math.min(2, Number(y1)).toFixed(0) // disallows millenia > 2
    }
  }

  if (y2) y2 = y1 === currentYear[0] ? Math.min(Number(currentYear[1]), Number(y2)).toFixed(0) : y2

  if (y3)
    y3 = y1 === currentYear[0] && y2 === currentYear[1] ? Math.min(Number(currentYear[2]), Number(y3)).toFixed(0) : y3

  if (y4)
    y4 =
      y1 === currentYear[0] && y2 === currentYear[1] && y3 === currentYear[2]
        ? Math.min(Number(currentYear[3]), Number(y4)).toFixed(0)
        : y4

  return `${d1}${d2}${m1 ? '.' : ''}${m1}${m2}${y1 ? '.' : ''}${y1}${y2}${y3}${y4}`
}
